/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 正整数
 * @param {string} str
 */
export function validPositiveInteger(str) {
  return /^[1-9]\d*$/.test(str)
}

/**
 * 正则格式：英文+数字
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  return /^[0-9a-zA-Z]+$/.test(str)
}

/**
 * 手机号码正则验证
 * @param {string} str
 */
export function validPhone(str) {
  return /^1[3456789]\d{9}$/.test(str)
}

/**
 *
 * @param {string} str
 * 请输入6-10位中文文字
 */
export function validParkname(str) {
  return /^[\u4e00-\u9fa5]{6,10}$/.test(str)
}

/**
 * 正整数2位+小数点后4位
 * @param {string} str
 */
export function validRate(str) {
  return /(^[0-9]{1,2}$)|(^[0-9]{1,6}[\.]{1}[0-9]{1,4}$)/.test(str)
}

/**
 * 邮箱验证
 * @param {string} str
 */
export function validEmail(str) {
  return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(str)
}

/**
 * 必须包含数字、英文字母、特殊符号且大于等于6位,特殊符号包括: ~!@#$%^&*
 * @param {string} str
 */
export function validPassword(str) {
  return /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{6,}$/.test(str)
}

/**
 * 用一个逗号隔开;结尾不需要加逗号
 * @param {string} str
 */
export function validCommas(str) {
  return /^\d+(,\d+)*$/.test(str)
}

/**
 * 银行卡号验证
 * @param {string} bankno
 * return 1 (正确) 2(不正确)
 */
export function validBankCard(bankno) {
  if (bankno) {
    var lastNum = bankno.substr(bankno.length - 1, 1)// 取出最后一位（与luhm进行比较）

    var first15Num = bankno.substr(0, bankno.length - 1)// 前15或18位
    var newArr = new Array()
    for (var i = first15Num.length - 1; i > -1; i--) { // 前15或18位倒序存进数组
      newArr.push(first15Num.substr(i, 1))
    }
    var arrJiShu = new Array() // 奇数位*2的积 <9
    var arrJiShu2 = new Array() // 奇数位*2的积 >9

    var arrOuShu = new Array() // 偶数位数组
    for (var j = 0; j < newArr.length; j++) {
      if ((j + 1) % 2 == 1) { // 奇数位
        if (parseInt(newArr[j]) * 2 < 9) {
          arrJiShu.push(parseInt(newArr[j]) * 2)
        } else {
          arrJiShu2.push(parseInt(newArr[j]) * 2)
        }
      } else { // 偶数位
        arrOuShu.push(newArr[j])
      }
    }

    var jishu_child1 = new Array()// 奇数位*2 >9 的分割之后的数组个位数
    var jishu_child2 = new Array()// 奇数位*2 >9 的分割之后的数组十位数
    for (var h = 0; h < arrJiShu2.length; h++) {
      jishu_child1.push(parseInt(arrJiShu2[h]) % 10)
      jishu_child2.push(parseInt(arrJiShu2[h]) / 10)
    }

    var sumJiShu = 0 // 奇数位*2 < 9 的数组之和
    var sumOuShu = 0 // 偶数位数组之和
    var sumJiShuChild1 = 0 // 奇数位*2 >9 的分割之后的数组个位数之和
    var sumJiShuChild2 = 0 // 奇数位*2 >9 的分割之后的数组十位数之和
    var sumTotal = 0
    for (var m = 0; m < arrJiShu.length; m++) {
      sumJiShu = sumJiShu + parseInt(arrJiShu[m])
    }

    for (var n = 0; n < arrOuShu.length; n++) {
      sumOuShu = sumOuShu + parseInt(arrOuShu[n])
    }

    for (var p = 0; p < jishu_child1.length; p++) {
      sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p])
      sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p])
    }
    // 计算总和
    sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2)

    // 计算Luhm值
    var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10
    var luhm = 10 - k

    if (lastNum == luhm) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}
